var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-sidebar',{attrs:{"id":"stock-stockcard-detail","bg-variant":"white","sidebar-class":"sidebar-lg","shadow":"","backdrop":"","no-header":"","right":""}},[_c('div',[_vm._v(" "+_vm._s(_vm.stockCard)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }